







































import Vue from 'vue';

export default Vue.extend({
  props: {
    headerText: { type: String },
    // false: sima szekció-cím nyíl és összecsukás nélkül (a fejléc-stílus közös marad)
    collapsible: { type: Boolean, default: true }
  },

  data() {
    return {
      visible: true
    }
  }
});
